<template>
  <div class="w-full">
      <vx-card class="trlistimage overflow-hidden" v-on="$listeners" @click="navigate_to_detail_view" ref="restaurantCard">
          <template slot="no-body">
            <!-- ITEM IMAGE -->
            <div class="item-img-container flex items-center justify-center cursor-pointer product-image"
                                      :style="appliedStyle"></div>

          </template>
      </vx-card>

  <!-- TITLE & DESCRIPTION -->
    <div class="trlistinfo">

      <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view">{{ item.user_property['Restaurant-Name'] }}</h6>
      <p class="trlistaddress"  @click="navigate_to_detail_view">{{ item.user_property['Address'] }}</p>
    </div>
    <div class="col-12 row">
      <StarRating :rating="item.review" />
    </div>
  </div>
</template>

<script>
import StarRating from '../../restaurantlist/components/StarRating.vue'

export default{
  props: {
    item: {
      type: Object,
      required: true
    },
    detail: {
      type: Function
    }
  },
  components: {
    StarRating
  },
  data () {
    return {
      image_height: 0,
      image_width: 0,
      appliedStyle: {
        'background-image': 'url('.concat(this.item.photoUrl).concat(')'),
        'height': `${this.image_height}px`
      }
    }
  },
  mounted () {
    this.setImageHeight()
  },
  methods: {
    navigate_to_detail_view () {
      this.detail(this.item)
    },
    setImageHeight () {
      this.image_width = this.$refs.restaurantCard.$el.clientWidth
      this.image_height = Math.floor((this.image_width * 40) / 57)
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        min-width: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);

        .grid-view-img{
            opacity: 0.9;
        }
    }

  .product-image{
    background-position: center;
    background-size: cover;
  }


  &.vx-card {
    background: transparent;
    border-radius: 5px;
  }
}
@media (max-width:820px)  {
  .trlistaddress{
    display:none;
  }
}
</style>
